import Link from 'next/link'
import React, {useState, useEffect} from 'react';


export default function DesktopWidget() {
    useEffect(() => {
        loadDeskpro();
    });

    return (
        <>
            <div className="contact-form-wrapper">
                <div className="container">
                    <div id="dp_newticket_form" style={{display: "none"}}></div>
                </div>
            </div>
        </>
    )
}

function loadDeskpro() {
    var DpNewTicket_Options = DpNewTicket_Options || {};
    DpNewTicket_Options.protocol = ('https:' == document.location.protocol ? 'https' : 'http');
    DpNewTicket_Options.deskproUrl = DpNewTicket_Options.protocol + '://helpdesk.file-tax.net/';
    DpNewTicket_Options.initialHeight = 700;
    DpNewTicket_Options.containerId = 'dp_newticket_form';
    DpNewTicket_Options.departmentId = 6;
    DpNewTicket_Options.languageId = 0;
    DpNewTicket_Options.formUserName = '';
    DpNewTicket_Options.formUserEmail = '';
    window.DpNewTicket_Options = DpNewTicket_Options;

    if (document.getElementsByTagName) {
        (function () {
            var scr = document.createElement('script');
            scr.type = 'text/javascript';
            scr.async = true;
            scr.src = DpNewTicket_Options.protocol + '://helpdesk.file-tax.net/web/javascripts/DeskPRO/User/TicketFormWidget/TicketFormWidget.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(scr);
        })();
    }
}
